module.exports = __webpack_public_path__ + "img/SHORT-SLEEVE-TEE_FRONT_BLUE-BACK.37a03968.jpg";